import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PushBus } from 'rev-shared/push/PushBus.Service';
import { PushService } from 'rev-shared/push/PushService';

@Injectable({
	providedIn: 'root'
})
export class SelfProducedService {

	constructor(
		private readonly PushService: PushService,
		private readonly PushBus: PushBus
	) { }

	public setPresenterReady(webcastId: string, ready: boolean): Promise<void> {
		return this.PushService.dispatchCommand('scheduledEvents:SetPresenterStatus', { webcastId, ready });
	}

	public onBroadcastStarting(webcastId): Observable<any> {
		return this.PushBus.getRxJsObservable(webcastId, 'Webcast.Presenter', ['BroadcastCountdownStarted']);
	}
}
